import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formatImage } from '@src/common/formatImage';
import styles from './index.css';

class Support extends PureComponent {

    static propTypes = {
        content: PropTypes.array
    }

    render() {
        const { content } = this.props;

        return (
            <div className={styles.support}>
                <div>
                    {
                        content.map((item, index) => {
                            return (
                                <div key={index}>
                                    <div className={styles.supportTitle}>{item.title}</div>
                                    <div className={styles.supportContent}>
                                        <a href={item.url} target="_blank" rel="noreferrer">
                                            <img src={formatImage(item.image)} alt={item.title} />
                                        </a>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
                <div className={styles.rights}>
                    <div className={styles.supportTitle}>版权声明</div>
                    <div className={styles.supportTitle} style={{ paddingLeft: '10px' }}>
                        凤凰网<a href="https://finance.ifeng.com/" target="_blank">财经</a>中心出品
                    </div>
                </div>
            </div>
        );
    }
}

export default Support;
